import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {justValues, weatherConditions} from './answers'

const answers = justValues(weatherConditions)

export const Weather = () => {
  const {submitAnswers} = useOutletContext()
  return (
    <div className="column">
      <section className="question">
        <div className="content size-xl">The weather conditions will be...</div>
      </section>
      <section className="answers">
        <div className="content">
          {answers.map(it => (
            <Button size="large" action={() => submitAnswers([it])} key={it}>
              {it}
            </Button>
          ))}
        </div>
      </section>
    </div>
  )
}
